<template>
  <micro-app
    v-bind="ngConfig"
    @mounted="domLoaded"
    :data="microAppData"
    @datachange="processChildMsg"
  ></micro-app>
</template>

<script>
// @ is an alias to /src
import { reactive, ref } from 'vue'
import config from '@/appsConfig'
import { getActiveApps } from '@micro-zoe/micro-app'
export default {
  name: 'ngApp',
  setup() {
    const ngConfig = ref(config['ngApp'])
    function domLoaded(e) {
      wrapRawMethod(e)
    }
    const microAppData = reactive({})
    function processChildMsg(e) {
      console.log(e.detail.data)
    }
    /**
     * @description 在angularApp 需要把挂载到body的dom挂载 转移到容器里的micro-app-body 中，以防样式隔离丢失
     */
    function wrapRawMethod(e) {
      // 劫持原生方法
      const { container } = e.detail
      const containerBody = container.querySelector('micro-app-body')
      document.body.removeChild = wrapBodyAppend('removeChild', containerBody)
      document.body.remove = wrapBodyAppend('remove', containerBody)
      document.body.append = wrapBodyAppend('append', containerBody)
      document.body.appendChild = wrapBodyAppend('appendChild', containerBody)
      document.body.classList.add = wrapBodyClassList('add', containerBody)
      document.body.classList.remove = wrapBodyClassList(
        'remove',
        containerBody
      )
    }
    function wrapBodyAppend(method, container) {
      const rawMethod = document.body[method]
      return function (...args) {
        if (container && getActiveApps(true).includes('ngApp')) {
          return container[method](...args)
        } else {
          return rawMethod.apply(document.body, args)
        }
      }
    }
    /**
     * @description 在angularApp 需要把挂载到body的class 转移到容器里的micro-app-body 中，以防样式隔离丢失
     */
    function wrapBodyClassList(method, container) {
      const rawMethod = document.body.classList[method]
      return function (...args) {
        if (
          container &&
          location.hash.slice(1).startsWith(ngConfig.value.baseroute)
        ) {
          return container.classList[method](...args)
        } else {
          return rawMethod.apply(document.body.classList, args)
        }
      }
    }
    return {
      processChildMsg,
      ngConfig,
      domLoaded,
      microAppData,
    }
  },
}
</script>
